import { FormControl, ValidationErrors } from '@angular/forms';

export const commaSeparatedDecimalValidator: (control: FormControl) => ValidationErrors | null = (
  control: FormControl,
) => {
  const numberString = control.value;
  const number = convertToNumber(numberString);

  return isNaN(number) ? { commaSeparatedDecimal: true } : null;
};

export const convertToNumber = (commaSeparatedDecimal: string) => {
  if (!commaSeparatedDecimal) {
    return null;
  }
  return Number(commaSeparatedDecimal.replace(',', '.'));
};
